// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__O4t6Z","footer_container":"Footer_footer_container__eYXut","p":"Footer_p__u8gg+"};